import React, { useContext, useRef, useState, useEffect } from "react";
import { Fade } from "react-reveal";
import emoji from "react-easy-emoji";
import * as d3 from 'd3';
import graphData from './Greeting_Network.json';
import "./Greeting.scss";

import landingPerson from "../../assets/lottie/landingPerson";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { illustration, greeting } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
// import d3 from "https://d3js.org/d3.v7.min.js";

function setWork(experience_name) {
  console.log(experience_name);
  switch (experience_name) {
    case "Topic Modeling":
      console.log("Topic modeling selected");
      break;


  }
}
export default function Greeting() {
  const { isDark } = useContext(StyleContext);


  const svgRef = useRef();
  const [info, setInfo] = useState('Click a node to see its name here');

  useEffect(() => {
    const width = 800, height = 600;
    const svg = d3.select(svgRef.current)
      .attr("width", width)
      .attr("height", height);

    const simulation = d3.forceSimulation(graphData.nodes)
      .force("link", d3.forceLink(graphData.links).id(d => d.id).distance(150))
      .force("charge", d3.forceManyBody().strength(-400))
      .force("center", d3.forceCenter(width / 2, height / 2));
    const drag = d3.drag()
      .on("start", (event, d) => {
        if (!event.active) simulation.alphaTarget(0.3).restart();
        d.fx = d.x;
        d.fy = d.y;
      })
      .on("drag", (event, d) => {
        d.fx = Math.max(15, Math.min(width - 15, event.x));
        d.fy = Math.max(15, Math.min(height - 15, event.y));
      })
      .on("end", (event, d) => {
        if (!event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
      });

    const link = svg.append("g")
      .attr("class", "links")
      .selectAll("line")
      .data(graphData.links)
      .enter().append("line")
      .attr("class", "link")
      .attr("stroke", "#999")
      .attr("stroke-opacity", 0.6)
      .attr("stroke-width", 1.5);

    const node = svg.append("g")
      .attr("class", "nodes")
      .selectAll("circle")
      .data(graphData.nodes)
      .enter().append("circle")
      .attr("class", "node")
      .attr("r", 15)
      .attr("fill", "#69b3a2")
      .attr("stroke", "#555")
      .attr("stroke-width", 1.5)
      .on("click", (event, d) => setWork(d.id))
      .call(drag);
    const label = svg.append("g")
      .selectAll("text")
      .data(graphData.nodes)
      .enter().append("text")
      .attr("dx", 12)
      .attr("dy", ".35em")
      .text(d => d.id);

    simulation.nodes(graphData.nodes).on("tick", () => {
      link
        .attr("x1", d => d.source.x)
        .attr("y1", d => d.source.y)
        .attr("x2", d => d.target.x)
        .attr("y2", d => d.target.y);

      node
        .attr("cx", d => d.x = Math.max(15, Math.min(width - 15, d.x)))
        .attr("cy", d => d.y = Math.max(15, Math.min(height - 15, d.y)));


      label
        .attr("x", d => d.x)
        .attr("y", d => d.y);
    });

    simulation.force("link").links(graphData.links);

  }, []);
  if (!greeting.displayGreeting) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1
                className={isDark ? "dark-mode greeting-text" : "greeting-text"}
              >
                {" "}
                {greeting.title}{" "}
                <span className="wave-emoji">{emoji("👋")}</span>
              </h1>
              <p
                className={
                  isDark
                    ? "dark-mode greeting-text-p"
                    : "greeting-text-p subTitle"
                }
              >
                {greeting.subTitle}
              </p>
              <SocialMedia />
              <div className="button-greeting-div">
                <Button text="Contact me" href="#contact" />
                {greeting.resumeLink && (
                  <a
                    href={require("./resume.pdf")}
                    download="Resume.pdf"
                    className="download-link-button"
                  >
                    <Button text="Download my resume" />
                  </a>
                )}
                {/* <Button text="Google Scholar" href="https://scholar.google.com/citations?user=tyYCmyUAAAAJ&hl=en" /> */}
              </div>
            </div>
          </div>
          <div className="greeting-image-div" id="graph-container">
            {/* {illustration.animated ? (
              <DisplayLottie animationData={landingPerson} />
            ) : (
              <img
                alt="man sitting on table"
                src={require("../../assets/images/manOnTable.svg")}
              ></img>
            )} */}
            <div className="image-content-profile">
              <img
                src="https://avatars.githubusercontent.com/u/16039618?v=4"
                alt={"Noah Britt"}
                className="profile-image"
              />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}
